<template>
  <div>
    <b-button v-b-toggle.sidebar-no-header><i class="fas fa-bars fa-2x" ></i></b-button><br>
    <b-sidebar id="sidebar-no-header" bg-variant='dark' aria-labelledby="sidebar-no-header-title" no-header shadow>
      <template #default="{ hide }">
        <div class="p-3">
          <h4 id="sidebar-no-header-title" style="color: white;">AIMS</h4>
          <nav class="mb-3">
            <b-nav vertical>
              <b-nav-item style="background: transparent; color: blue;" active ><router-link to="/dashboard">Home</router-link></b-nav-item>
              <b-nav-item style="background: transparent; color: blue;"><router-link to="/manage">Manage</router-link></b-nav-item>
            </b-nav>
          </nav>
          <b-button variant="primary" block @click="hide">Close</b-button>
        </div>
      </template>
    </b-sidebar>
  </div>
</template>
<script>
export default {

}
</script>
<style scoped>

</style>